module.exports = __webpack_public_path__ + "index_pc/img/b4.9becf25c.png";